<template>
    <tbody>
        <tr style="cursor:pointer" @click="toggle">
            <td>
                <i class="fas fa-caret-down" aria-hidden="true" v-if="isOpen"></i>
                <i class="fas fa-caret-right" aria-hidden="true" v-else></i>
            </td>
            <td>
                to-do@agency.com<br>
                {{ row.agency_name }}
            </td>
            <td>
                {{ row.customer }}
                <template v-if="row.division">
                    <br>{{ row.division }}
                </template>
            </td>
            <td>{{ row.io_number }}</td>
            <td>{{ row.period_friendly }}</td>
            <td style="text-align: right; padding-right: 8px">{{ money(row.total_net) }}</td>
            <td>{{ row.state }}</td>
            <td>{{ row.received_on }}</td>
        </tr>
        <insertion-order-detail 
            v-if="isOpen"
            :budget_io="row.id" 
            @refresh="$emit('refresh')"
        />
    </tbody>
</template>

<script>
import InsertionOrderDetail from "./insertion-order-detail";

export default {
    components: {
        InsertionOrderDetail
    },
    props: {
        row: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isOpen: false,
        };
    },
    methods: {
        toggle() {
            this.isOpen = !this.isOpen;
        },
    }
}
</script>